import React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Eyebrow, Highlight } from "./HomePage";

const contactItems = [
  {
    icon: "fas fa-phone-alt",
    title: "Hotline",
    value: "1800 309 2740",
    href: "tel:18003092740",
  },
  {
    icon: "fas fa-map-marker-alt",
    title: "Our Location",
    value: "642/1 Plot 30, Najafgarh Road Ind Area, West Delhi-110015",
  },
  {
    icon: "fas fa-envelope-open-text",
    title: "Official Email",
    value: "hello@swasthopd.com",
    href: "mailto:hello@swasthopd.com",
  },
];

const Contact = () => {
  return (
    <section className="relative overflow-hidden bg-[#f6f5f0] py-[40px] min-[992px]:py-[70px]">
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[55%] bg-[#e3efe0] [clip-path:ellipse(80%_100%_at_50%_100%)]" />
      <div className="relative max-w-[1240px] mx-auto px-[18px] min-[576px]:px-8 grid gap-12 min-[992px]:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] min-[992px]:items-center min-[1201px]:gap-10">
        {/* Copy */}
        <div>
          <Eyebrow>Have questions?</Eyebrow>
          <h2 className="mt-[15px] mb-[20px] text-[30px] min-[576px]:text-[38px] min-[1201px]:text-[42px] font-extrabold leading-[1.1] tracking-[-0.03em] text-[#0d2f27]">
            We're here to <Highlight>help you</Highlight>
          </h2>
          <p className="max-w-[520px] mb-[0px] text-[16px] min-[576px]:text-[18px] leading-[1.6] text-[#5b6b66]">
            Feel free to connect with our customer representative if you face
            any problems.
          </p>

          <ul className="mt-8 grid gap-3 p-0 list-none">
            {contactItems.map((item) => {
              const Value = item.href ? "a" : "p";
              return (
                <li
                  key={item.title}
                  className="group flex items-start gap-4 rounded-[24px] p-3 min-[576px]:p-4 bg-[#fff] border-[1px] border-solid border-[#0d2f27]/[0.06] shadow-[0_24px_48px_-28px_rgba(13,47,39,0.35)] transition duration-300 ease-out hover:-translate-y-1 hover:border-[#0d2f27]/[0.2] motion-reduce:transition-none motion-reduce:hover:translate-y-0"
                >
                  <span className="flex items-center justify-center shrink-0 w-[52px] h-[52px] rounded-full text-[20px] bg-[#e8f3ec] text-[#1f6b45] transition-colors duration-300 group-hover:bg-[#0d2f27] group-hover:text-[#d6ea4f]">
                    <i className={item.icon} aria-hidden="true" />
                  </span>
                  <div className="min-w-0">
                    <h5 className="mt-[2px] mb-[4px] text-[14px] font-semibold uppercase tracking-[0.06em] text-[#5b6b66]">
                      {item.title}
                    </h5>
                    <Value
                      {...(item.href ? { href: item.href } : {})}
                      className="block mb-[0px] text-[17px] min-[576px]:text-[19px] font-bold leading-[1.4] tracking-[-0.01em] text-[#0d2f27] break-words hover:text-[#1f8a4f]"
                    >
                      {item.value}
                    </Value>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Animation */}
        <div className="flex items-center justify-center aspect-square w-full max-w-[560px] mx-auto rounded-[32px] bg-[#fff] border-[1px] border-solid border-[#0d2f27]/[0.06] shadow-[0_32px_60px_-28px_rgba(13,47,39,0.45)] overflow-hidden">
          <DotLottieReact
            src="/assets/lottie/online-doctor-3d.json"
            loop
            autoplay
            className="w-[90%] h-[90%]"
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;
